const React = require('react');

/**
 * @type { React.Context<import("../types").IUniversalContext> }
 */
const UniversalContext = React.createContext(null);

module.exports = UniversalContext;
